import {
	sendSmsCodeApi, 
	smsRegisterApi,
	smsLoginApi,
	smsPwdLoginApi,
	refreshTokenApi,
	registerCargoApi,
	pwdLoginApi,
	sendVoiceCodeApi,
	resetPwdApi
} from '@/apis-global/system.js'
export default {
	async sendSmsCode(context, mobile) {
		return sendSmsCodeApi(mobile)
	},
	async smsRegister(context, body) {
		return smsRegisterApi(body)
	},
	async smsLogin(context, body) {
		return smsLoginApi(body)
	},
	async smsPwdLogin(context, body) {
		return smsPwdLoginApi(body)
	},
	async refreshToken(context, refreshToken) {
		return refreshTokenApi({refreshToken})
	},
	async registerCargo(context, body) {
		return registerCargoApi(body)
	},
	async pwdLogin(context, body) {
		return pwdLoginApi(body)
	},
	async sendVoiceCode(context, body) {
		return sendVoiceCodeApi(body)
	},
	async resetPwd(context, body) {
		return resetPwdApi(body)
	}
}